import { Logger, SupportedProducts } from 'atp-api-logger';

import { settings } from '@/_config';

const product = SupportedProducts.INSTRUCTOR_PORTAL;

export const logger = Logger.getInstance(product, settings.isProduction);
